import clsx from 'clsx'
import {useEffect, useState} from 'react'
import {FormControl, InputGroup, Table} from 'react-bootstrap'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const StoreFaqsPlugin = () => {
  const [configID, setConfigId] = useState<any>(0)
  const [config, setConfig] = useState<any>({
    video_title: '',
    video_link: '',
    is_video_enabled: true,
    is_faq_enabled: true,
    faqs_config: [],
  })
  const [faqTitle, setFaqTitle] = useState<any>('')
  const [faqMessage, setFaqMessage] = useState<any>('')

  useEffect(() => {
    getConfiguration()
  }, [])

  const createNewFaqs = async () => {
    if (faqTitle.trim().length !== 0 && faqMessage.trim().length !== 0) {
      let updatedFaqs = [...config.faqs_config]
      updatedFaqs.push({title: faqTitle, message: faqMessage})
      setConfig({...config, faqs_config: updatedFaqs})
      updateConfiguration({...config, faqs_config: updatedFaqs})
    } else {
      ErrorToastUtils('Please Fill All Details')
    }
  }

  const handleFaqsInputChange = (event: any, index: number) => {
    const {name, value} = event.target
    let updatedFaqs = [...config.faqs_config]

    if (name === 'title') {
      updatedFaqs[index].title = value
    } else if (name === 'message') {
      updatedFaqs[index].message = value
    }

    setConfig({...config, faqs_config: updatedFaqs})
  }

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.value
    let checkedValue = event.target.checked

    if (name === 'is_video_enabled' || name === 'is_faq_enabled') {
      setConfig({...config, [name]: checkedValue})
      updateConfiguration({...config, [name]: checkedValue})
    } else {
      setConfig({...config, [name]: value})
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(config)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('store_faqs')

    if (result.success) {
      let parsedData = result.data.values
      setConfigId(result.data._id)
      setConfig({
        video_title: parsedData.video_title,
        video_link: parsedData.video_link,
        is_video_enabled: parsedData.is_video_enabled,
        is_faq_enabled: parsedData.is_faq_enabled,
        faqs_config: parsedData.faqs_config,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <>
      <div className='card'>
        <div className='row no-gutters mt-5'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Video Title</strong>
            </p>
            <p className='text-muted'>Enter Video Title</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <input
              className='form-control form-solid w-25'
              name='video_title'
              value={config.video_title}
              onChange={(event) => handleChange(event)}
              onBlur={onBlurUpdate}
            />
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enter Video Link</strong>
            </p>
            <p className='text-danger'>
              A YouTube video link is required; otherwise, the thumbnail will not be shown on
              mobile.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <input
              className='form-control form-solid w-25'
              name='video_link'
              value={config.video_link}
              onChange={(event) => handleChange(event)}
              onBlur={onBlurUpdate}
            />
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Video</strong>
            </p>
            <p className='text-muted'>Is Video Enabled</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='is_video_enabled'
                checked={config.is_video_enabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Faqs</strong>
            </p>
            <p className='text-muted'>Is Faqs Enabled</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='is_faq_enabled'
                checked={config.is_faq_enabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-3'>
        <div>
          <div className='card'>
            <div className='card-title p-4'>
              <div className='d-flex justify-content-end'>
                <button
                  className='btn btn-primary'
                  data-bs-toggle='modal'
                  data-bs-target='#add_credit_plan'
                >
                  Add Faqs
                </button>
              </div>
            </div>
            <div className='card-body'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Questions</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {config?.faqs_config.map((faq: any, index: number) => {
                    return (
                      <tr key={index}>
                        <td>
                          <InputGroup>
                            <FormControl
                              placeholder='Faq Title'
                              name='title'
                              value={faq?.title}
                              onChange={(event) => handleFaqsInputChange(event, index)}
                              onBlur={onBlurUpdate}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup>
                            <FormControl
                              as='textarea'
                              placeholder='Faq Message'
                              name='message'
                              value={faq?.message}
                              onChange={(event) => handleFaqsInputChange(event, index)}
                              onBlur={onBlurUpdate}
                            />
                          </InputGroup>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>

        <div className='modal fade' tabIndex={-1} id='add_credit_plan'>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Add New Faqs</h5>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <i className='fa-solid fa-xmark'></i>
                </div>
              </div>
              <div className='modal-body'>
                <input
                  placeholder='Faq Title'
                  type='text'
                  name='title'
                  className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                  autoComplete='off'
                  value={faqTitle}
                  onChange={(e) => setFaqTitle(e.target.value)}
                />
                &nbsp;&nbsp;&nbsp;
                <textarea
                  className='form-control form-control-solid mb-3'
                  rows={3}
                  data-kt-element='input'
                  placeholder='Faq message'
                  value={faqMessage}
                  id='message'
                  onChange={(e) => setFaqMessage(e.target.value)}
                ></textarea>
              </div>

              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  data-bs-dismiss='modal'
                  onClick={createNewFaqs}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StoreFaqsPlugin
